<template>
    <div id="MobileHome">
        <div class="content" ref="list">
            <header>
                <img src="../../assets/img/logo.jpg" alt="">
                <div>济南城管“便民公厕”地图</div>
            </header>
            <div class="map-box">
                <div class="map" id="map"></div>
            </div>

        </div>
        <div class="content-box" ref="list">
            <!--            <div class="search-view" v-show="navContent !== 'details'">-->
            <!--                <div class="search-box">-->
            <!--                    <input type="text" placeholder="请输入公厕名称" v-model="keywords">-->
            <!--                    <div>-->
            <!--                        <div class="icon-bg" @click="getSearchSchool">-->
            <!--                            <img src="../../assets/img/sousuo.png" alt="">-->
            <!--                        </div>-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--                <el-select @change="areaSelectChanged" style="display: block;width: 140px;margin: 0 0 0 5px"-->
            <!--                           v-model="areaSelect" placeholder="请选择区县">-->
            <!--                    <el-option-->
            <!--                        v-for="(item,idx) in selectList"-->
            <!--                        :key="idx"-->
            <!--                        :label="item.title"-->
            <!--                        :value="item.title">-->
            <!--                    </el-option>-->
            <!--                </el-select>-->
            <!--            </div>-->
            <!--            <div class="select-box" v-show="navContent !== 'details'">-->
            <!--                &lt;!&ndash;<div>筛选</div>&ndash;&gt;-->
            <!--                <div>-->
            <!--                    <div-->
            <!--                            v-for="(item, index) of selectBtn"-->
            <!--                            :key="index" :class="{select: item.select}"-->
            <!--                            @click="changeSelect(item)"-->
            <!--                    >{{item.name}}-->
            <!--                    </div>-->
            <!--                </div>-->
            <!--            </div>-->
            <div class="nav-list">
                <div class="school-box" v-show="navContent === 'school'">
                    <div :class="{'school-item': true, 'school-item-focus': schoolItemIndex === index}"
                         v-for="(school, index) of highSchoolList"
                         :key="index"
                         @click="toSchoolInfo(school, index)"
                    >
                        <div style="flex: 1">{{school.title}}</div>
                        <span style="width: 55px;text-align: center;font-size: 14px">{{school.meters}}米</span>
                        <span>〉</span>
                    </div>
                </div>
                <div class="school-details" v-show="navContent === 'details'">
                    <div @click="navContent = 'school'">
                        <i class="el-icon-arrow-left"></i>
                        <span>返回</span>
                    </div>
                    <Table
                        style="background-color: #f2a807"
                        :data="mockeTableData"
                        max-height="605px"
                    >
                        <TableColumn
                            prop="county"
                            label="区县"
                            width='80'
                        >
                        </TableColumn>
                        <!--                        <TableColumn-->
                        <!--                            prop="street"-->
                        <!--                            label="街道"-->
                        <!--                            width='120'-->
                        <!--                        >-->
                        <!--                        </TableColumn>-->
                        <TableColumn
                            prop="title"
                            label="名称"
                        >
                        </TableColumn>
                        <TableColumn
                            label="操作栏"
                            width="160"
                        >
                            <template slot-scope="scope">
                                <div style="display: flex;align-items: center">
                                    <el-dropdown trigger="click" style="margin-right: 5px">
                                        <el-button type="text" size="mini">到这去</el-button>
                                        <el-dropdown-menu slot="dropdown">
                                            <el-dropdown-item @click.native="handleCommand(scope.row,'gaode')">高德地图</el-dropdown-item>
                                            <el-dropdown-item  @click.native="handleCommand(scope.row,'tengxun')">腾讯地图</el-dropdown-item>
                                            <el-dropdown-item  @click.native="handleCommand(scope.row,'baidu')">百度地图</el-dropdown-item>
                                        </el-dropdown-menu>
                                    </el-dropdown>
<!--                                    <el-button type="text" @click="planRoute(scope.row)" size="mini">到这去</el-button>-->
                                    <el-button type="text" @click="goFeedsBack(scope.row)" size="mini">反馈</el-button>
                                    <el-button type="text" style="color: #aaa;font-size: 12px" disabled
                                               v-if="scope.row.thumbs.length===0||!scope.row.thumbs">暂无图片
                                    </el-button>
                                    <el-image v-else :preview-src-list="getImgList(scope.row)"
                                              :src="require('../../assets/img/checkImgList.png')"
                                              style="width: 48px;height: 12px;margin-left: 10px"></el-image>
                                </div>
                            </template>
                        </TableColumn>
                        <!--                        <TableColumn-->
                        <!--                            prop="name"-->
                        <!--                            label="路长"-->
                        <!--                            width='80'-->
                        <!--                        >-->
                        <!--                        </TableColumn>-->
                        <!--                        <TableColumn-->
                        <!--                            prop="startLocation"-->
                        <!--                            label="起点"-->
                        <!--                            width='120'-->
                        <!--                        >-->
                        <!--                        </TableColumn>-->
                        <!--                        <TableColumn-->
                        <!--                            prop="endLocation"-->
                        <!--                            label="终点"-->
                        <!--                            width='120'-->
                        <!--                        >-->
                        <!--                        </TableColumn>-->
                        <!--                        <TableColumn-->
                        <!--                            prop="tel"-->
                        <!--                            label="电话"-->
                        <!--                            width='120'-->
                        <!--                        >-->
                        <!--                            <template slot-scope="scope">-->
                        <!--                                <a style="color: #000" :href="'tel:'+scope.row.tel">{{scope.row.tel
                        }}</a>-->
                        <!--                            </template>-->
                        <!--                        </TableColumn>-->
                    </Table>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import * as echarts from 'echarts'
    import axios from 'axios'
    import * as qs from 'query-string'
    import moment from 'moment'
    import {Table, TableColumn} from 'element-ui'

    export default {
        name: "MobileHome",
        components: {
            Table,
            TableColumn
        },
        data() {
            return {
                keywords: '',
                description: false,
                loading: false,
                finished: false,
                schoolList: [],
                stationId: '',
                mockeTableData: [],
                selectBtn: [
                    {name: '供暖管家', select: true, stype: 1},
                    {name: '营业厅', select: false, stype: 2}
                ],
                schoolParams: {
                    catid: 603,
                    stype: '',
                    title: '',
                },
                leftNews: [],
                mapObj: null,
                highSchoolList: [],
                // nav内容显示内容 true 学校 false 为资讯
                navContent: 'school',
                newParams: {
                    // 资讯604
                    catid: 604,
                    num: 20,
                    page: 1,
                    thumb: 0,
                    // 学校id
                    // school: '',
                    // 学校名称
                    // title: ''
                },
                schoolInfo: '',
                schoolItemIndex: '',
                schoolDetails: {},
                allowRequest: true,
                infoTab: [
                    {name: '动态', newstype: 1, select: true},
                    {name: '招考', newstype: 2, select: false},
                    {name: '师资', newstype: 3, select: false},
                    {name: '教学', newstype: 4, select: false}
                ],
                infoType: 1,
                areaParams: {
                    type: 2,
                    s_type: 1,
                    area: '',
                },
                selectList: [],
                areaSelect: '',
                userLocation: []
            }
        },
        methods: {
            getImgList(item) {
                const list = []
                item.thumbs.map(item => {
                    list.push(item.fileurl)
                })
                return list
            },
            goFeedsBack(item) {
                this.$router.push({
                    path: '/feedsBack',
                    query: {
                        title: item.title
                    }
                })
            },
            handleCommand(item,name){
                let userLocation=JSON.parse(JSON.stringify(this.userLocation))
                let endPostion = [item.longitude, item.latitude]
                if(name==='gaode'){
                    window.open(
                        `https://uri.amap.com/navigation?from=${userLocation.join(',')}&to=${endPostion.join(',')},${item.title}&mode=car&policy=1&callnative=1`
                    )
                }
                if(name==='tengxun'){
                    const ended=endPostion.reverse()
                    const form=userLocation.reverse()
                    window.open(
                        `  https://apis.map.qq.com/uri/v1/routeplan?type=drive&from=当前位置&fromcoord=${form.join(',')}&to=${item.title}&tocoord=${ended.join(',')}&policy=1&referer=UOVBZ-Z42Y6-NVSS5-EYGNO-QRJJ3-4GFSV`
                    )
                }
                if(name==='baidu'){
                    const ended=endPostion.reverse()
                    const form=userLocation.reverse()
                    window.open(
                        `https://api.map.baidu.com/direction?origin=${form.join(',')}&destination=${ended.join(',')}&mode=driving&region=济南&output=html&coord_type=gcj02`
                    )
                }
            },
            areaSelectChanged(val) {
                const {selectList} = this
                axios.get(`/index.php?m=content&c=gongce&a=getRoadByCounty&county=${val}`).then(res => {
                    this.highSchoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.schoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.mapObj.destroy();
                    const posi = selectList.filter(item => item.title === val)
                    this.initMap(posi[0].center.split(','))
                })
            },
            getSelectList() {
                axios.post(`/index.php?m=content&c=gongce&a=getCounty`).then(({data}) => {
                    this.$set(this, 'selectList', data[0])
                })
            },
            changeSelect(item) {
                console.log(item)
                this.selectBtn.map(btn => btn.select = false)
                this.navContent = 'details'
                item.select = true
                this.navContent = 'school'
                this.areaParams.s_type = item.stype
                this.areaParams.type = 2
                this.getLeftSchool()
            },
            /**
             * 初始化地图
             */
            initMap(posi) {
                this.$nextTick(() => {
                    let map = new AMap.Map('map', {
                        center: posi ? posi : [117.000923, 36.675807],
                        zoom: 12
                    })
                    this.mapObj = map;
                    let markerIcon = ''
                    this.schoolList.map(item => {
                        let icon = null;
                        if (item.s_type == 1) {
                            icon = new AMap.Icon({
                                // size: new AMap.Size(40, 50),    // 图标尺寸
                                imageSize: new AMap.Size(16, 25),
                                // offset: new AMap.Pixel(-9,-25),
                                // anchor:'top-center', // 设置锚点方位
                                image: require('../../assets/img/icon.png'),  // Icon的图像
                            });
                        } else {
                            icon = new AMap.Icon({
                                // size: new AMap.Size(40, 50),    // 图标尺寸
                                imageSize: new AMap.Size(16, 25),
                                // offset: new AMap.Pixel(-9,-25),
                                // anchor:'top-center', // 设置锚点方位
                                image: require('../../assets/img/iconBlue.png'),  // Icon的图像
                            });
                        }
                        item.center = [parseFloat(item.longitude), parseFloat(item.latitude)]
                        var marker = new AMap.Marker({
                            position: new AMap.LngLat(...item.center),   // 经纬度对象，也可以是经纬度构成的一维数组[116.39, 39.9]
                            data: {...item},
                            icon: icon,
                        })
                        // 将创建的点标记添加到已有的地图实例：
                        map.add(marker);
                        marker.on('click', (e) => this.clickHandler(e, map));
                    })
                    this.map = map
                    this.getUserLocation()
                })
            },
            getUserLocation() {
                const {mapObj} = this
                const _this = this
                const icon = require('../../assets/img/center.png')
                mapObj.plugin('AMap.Geolocation', function () {
                    const geolocation = new AMap.Geolocation({
                        enableHighAccuracy: true,//是否使用高精度定位，默认:true
                        GeoLocationFirst: true,
                        animation: 'AMAP_ANIMATION_BOUNCE',
                        clickable: false,
                        markerOptions: {
                            // icon:require('../../assets/img/locationIconSvg.svg'),
                            content: `<div style="text-align: center;font-size: 14px;color: #e4393c"><img src="${icon}" alt=""><div>您现在所在位置</div></div>`,
                            zIndex: 10000,
                            offset: new AMap.Pixel(-40, -34),
                        },
                        timeout: 10000,          //超过10秒后停止定位，默认：无穷大
                        maximumAge: 0,           //定位结果缓存0毫秒，默认：0
                        convert: true,           //自动偏移坐标，偏移后的坐标为高德坐标，默认：true
                        showButton: true,        //显示定位按钮，默认：true
                        buttonPosition: 'LB',    //定位按钮停靠位置，默认：'LB'，左下角
                        buttonOffset: new AMap.Pixel(10, 20),//定位按钮与设置的停靠位置的偏移量，默认：Pixel(10, 20)
                        showMarker: true,        //定位成功后在定位到的位置显示点标记，默认：true
                        showCircle: true,        //定位成功后用圆圈表示定位精度范围，默认：true
                        panToLocation: true,     //定位成功后将定位到的位置作为地图中心点，默认：true
                        zoomToAccuracy: false      //定位成功后调整地图视野范围使定位位置及精度范围视野内可见，默认：false
                    });
                    mapObj.addControl(geolocation);
                    geolocation.getCurrentPosition();
                    AMap.event.addListener(geolocation, 'complete', onComplete);//返回定位信息
                    AMap.event.addListener(geolocation, 'error', onError);      //返回定位出错信息
                });

                function onComplete(data) {
                    // data是具体的定位信息
                    var circle = new AMap.Circle({
                        center: new AMap.LngLat(data.position.lng, data.position.lat), // 圆心位置
                        radius: 3000,  //半径
                        strokeColor: "#F33",  //线颜色
                        strokeOpacity: 1,  //线透明度
                        strokeWeight: 3,  //线粗细度
                        fillColor: "#ee2200",  //填充颜色
                        fillOpacity: 0 //填充透明度
                    });
                    mapObj.add(circle)
                    _this.userLocation = [data.position.lng, data.position.lat]
                    _this.computedMeters()
                }

                function onError(data) {
                    // 定位出错
                    console.log(data)
                }
            },
            computedMeters() {
                let datas = JSON.stringify(this.schoolList)
                datas = JSON.parse(datas)
                let newListData = []
                const flag = 3000
                datas.map(item => {
                    const meters = this.getMeters([item.longitude, item.latitude])
                    if (parseInt(meters) <= flag) {
                        item.meters = parseInt(meters)
                        newListData.push(item)
                    }
                })
                const newDatas = this.bubbleSort(newListData)
                this.$set(this, 'schoolList', newDatas)
                this.$set(this, 'highSchoolList', newDatas)

            },
            bubbleSort(arr) {
                for (var i = 0; i < arr.length - 1; i++) {
                    for (var j = 0; j < arr.length - i - 1; j++) {
                        if (arr[j]['meters'] > arr[j + 1]['meters']) {
                            var temp = arr[j];
                            arr[j] = arr[j + 1];
                            arr[j + 1] = temp;
                        }
                    }
                }
                return arr;
            },
            getMeters(endPostion) {
                const {userLocation} = this
                return AMap.GeometryUtil.distance(userLocation, endPostion);
            },
            getAllSchool() {
                axios.post(`/index.php?m=content&c=gongce&a=lists`).then(res => {
                    this.schoolList = res.data
                    this.highSchoolList = res.data
                    this.initMap()
                })
            },
            getSearchSchool() {
                this.areaParams.type = 1;
                // this.areaParams.s_type='';
                this.getLeftSchool()
            },
            getLeftSchool() {
                axios.post(`/index.php?m=content&c=gongce&a=lists&title=${this.keywords}`).then(res => {
                    this.highSchoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.schoolList = res.data.map((item, index) => {
                        return {...item, index}
                    })
                    this.mapObj.destroy();
                    const firstRoad = this.schoolList[0]
                    this.initMap([firstRoad.longitude, firstRoad.latitude])
                })
            },
            /**
             * 跳转学校的详情
             */
            getmockeTableData(stype) {
                const url = '/index.php?m=content&c=gongce&a=roadInfo'
                axios.post(`${url}&id=${this.stationId}`).then(res => {
                    this.mockeTableData = res.data;
                })
            },
            toSchoolInfo(school, index) {
                this.schoolItemIndex = index
                this.stationId = school.id;
                this.clickHandler(school, this.map)
                // this.map.setZoomAndCenter(this.map.getZoom(), [parseFloat(school.longitude), parseFloat(school.latitude)]); //同时设置地图层级与中心点
                this.navContent = 'details'
                // this.getmockeTableData(this.stationId)
            },
            /**
             * 获得学校的信息
             */
            getSchoolInfo(id, newstype) {
                axios.post(`http://www.jinanenergy.cn/index.php?m=api&c=content&a=newsList&catid=42&${qs.stringify({
                    school: id,
                    newstype
                })}`).then(res => {
                    console.log(res)
                    this.schoolDetails.zixun = res.data.data.news
                })
            },
            /**
             * 切换学校资讯的tab
             */
            changeSchoolInfoTab(item) {
                this.infoTab.map(tab => {
                    tab.select = false
                })
                item.select = true
                this.infoType = item.newstype
                this.getSchoolInfo(this.schoolDetails.school.id, item.newstype)
            },
            /**
             * 找到学校的位置
             */
            findSchool(school) {
                let infoWindow = new AMap.InfoWindow({
                    offset: new AMap.Pixel(0, -20),
                    content: `<div class="info-window">
                                <div>${school.title}</div>
                              </div>`
                })
                infoWindow.open(this.map, [school.longitude, school.latitude])
                this.map.setZoomAndCenter(this.map.getZoom(), [parseFloat(school.longitude), parseFloat(school.latitude)]); //同时设置地图层级与中心点
                this.map.setZoom(17);
            },
            /**
             * 初始化内容中的 分数线
             */
            clickHandler(event, map) {
                let data = event.target ? event.target.Ce.data : event
                let s_type = event.target ? event.target.Ce.data.s_type : this.areaParams.s_type
                this.map.setCenter([data.longitude, data.latitude]);
                this.map.setZoom(17);
                this.schoolInfo = true;
                this.navContent = 'details'
                this.stationId = data.id;
                console.log(data.longitude, data.latitude)
                this.getmockeTableData(s_type)
            },
            /**
             * 跳转外连接
             */
            toOutLink(item) {
                if (item.islink !== '0') {
                    window.open(item.url)
                }
            },
            /**
             * 上拉加载
             */
        },
        mounted() {
            this.getAllSchool()
            this.getSelectList()
            // this.getLeftSchool()
        },
    }
</script>

<style scoped lang="less">
    #MobileHome {
        .serviceScope {
            display: block;
            height: 70px;
            overflow-y: auto;
        }

        .content {
            display: flex;
            height: 100vh;
            width: 100%;
            position: absolute;
            overflow-x: hidden;
            overflow-y: auto;
            background: white;
            /*background-color: #C8C8C8*/

            .map-box {
                z-index: 200;
                position: relative;
                width: 100%;
                height: 65vh;

                .map {
                    z-index: 200;
                    position: fixed;
                    width: 100%;
                    height: 65vh;
                }

                .app-download {
                    position: absolute;
                    width: 40vw;
                    height: 10vw;
                    background: rgb(21, 130, 159);
                    color: white;
                    right: 5vw;
                    bottom: 5vw;
                    z-index: 500;
                    border-radius: 2vw;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    font-size: .6em;

                    i {
                        margin-right: 1vw;
                    }
                }
            }
        }

        header {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            border-bottom: 1px solid #DDD;
            position: fixed;
            z-index: 300;
            background: #fff;
            backdrop-filter: blur(10px);
            -webkit-backdrop-filter: blur(10px);
            width: 100%;
            font-size: 16px;
            padding: 8px 16px 8px 10px;
            box-sizing: border-box;

            > img {
                width: 10vw;
                margin: 0 10vw 0 5vw;
            }

            > div {
                font-size: 16px;
                line-height: 20px;
                color: black;
            }
        }

        .content-box {
            z-index: 250;
            position: absolute;
            top: 65vh;
            width: 100%;
            display: flex;
            flex-direction: column;
            align-items: center;
            background: white;
            padding: 5vw 0;
            box-sizing: border-box;

            .search-view {
                display: flex;
                align-items: center;
                justify-content: center;
            }

            .search-box {
                border: 1px solid #DDD;
                width: 156px;
                height: 42px;
                box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                border-radius: 6px;
                display: flex;
                align-items: center;
                box-sizing: border-box;

                > input {
                    height: 60%;
                    width: 70%;
                    border: none;
                    margin-left: 20px;
                }

                > div {
                    width: 20%;
                    height: 80%;
                    border-left: 1px solid #ddd;
                    display: flex;
                    align-items: center;
                    justify-content: center;

                    .icon-bg {
                        background-color: #F5F5F5;
                        border-radius: 16px;
                        height: 28px;
                        width: 28px;
                        padding: 7px;
                        box-sizing: border-box;
                        cursor: pointer;
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                }
            }

            .select-box {
                margin: 0 auto 5vw;
                width: 80vw;
                height: 20vw;
                border-bottom: 1px solid #ddd;
                display: flex;
                align-items: center;
                justify-content: space-between;

                > div:nth-of-type(1) {
                    display: flex;
                    justify-content: space-between;
                    width: 100%;

                    > div {
                        /*margin-left: 10px;*/
                        width: 65px;
                        height: 24px;
                        border: 1px solid rgba(242, 242, 242, 1);
                        opacity: 1;
                        border-radius: 16px;
                        text-align: center;
                        line-height: 24px;
                        cursor: pointer;
                        font-size: .8em;
                    }

                    .select {
                        background: #EEEEEE;
                    }
                }

            }

            .nav-list {
                width: 100vw;
                box-sizing: border-box;
                /*height: calc(100% - 120px);*/
                overflow: auto;
                /*修改滚动条样式*/

                .nav-title {
                    font-size: 16px;
                    font-weight: bold;
                    width: 80vw;
                    margin: 0 auto;
                }

                .school-box {
                    .school-item {
                        width: 80vw;
                        margin: 10px auto;
                        display: flex;
                        justify-content: space-between;
                        align-items: center;
                        background: #FFF;
                        border: 1px solid rgba(0, 0, 0, 0.05);
                        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
                        border-radius: 6px;
                        font-size: 14px;
                        line-height: 20px;
                        padding: 12px 16px;
                        cursor: pointer;
                        user-select: none;
                        color: rgba(51, 51, 51, 1);
                        font-weight: 600;
                        box-sizing: border-box;

                        &:hover {
                            background: #ffe800;
                            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.1);
                            border: 1px solid #00809D;
                            color: #00809D;
                        }

                        > span {
                            color: #999999;
                        }
                    }

                    .school-item-focus {
                        background: #ffe800;
                        box-shadow: 0px 3px 5px rgba(0, 0, 0, 0.1);
                        border: 1px solid #00809D;
                        color: #00809D;
                    }
                }
            }
        }
    }

    .list-item {
        margin: 10px auto;
        width: 80vw;

        .item-top {
            width: 100%;
            display: flex;
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
            border-radius: 6px;
            box-sizing: border-box;
            cursor: pointer;

            .banner-box {
                width: 78px;
                height: 76px;
                overflow: hidden;

                > img {
                    width: 100%;
                    height: 100%;
                    object-fit: cover;
                }
            }

            .item-content {
                height: 76px;
                margin-left: 10px;
                display: flex;
                flex-direction: column;
                justify-content: space-around;

                > div:nth-of-type(1) {
                    width: 149px;
                    height: 58px;
                    font-size: 13px;
                    color: rgba(51, 51, 51, 1);
                }

                > div:nth-of-type(2) {
                    /*width: 65px;*/
                    height: 16px;
                    font-size: 12px;
                    color: rgba(118, 118, 118, 1);
                }
            }
        }

        .item-bottom {
            margin-top: 10px;
            width: 100%;
            display: flex;
            flex-direction: column;
            padding: 10px;
            border: 1px solid rgba(0, 0, 0, 0.05);
            box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
            border-radius: 6px;
            box-sizing: border-box;
            cursor: pointer;

            > div:nth-of-type(1) {
                /*width: 244px;*/
                height: 58px;
                font-size: 13px;
            }

            > div:nth-of-type(2) {
                height: 16px;
                font-size: 12px;
            }
        }
    }

    .school-info {
        /*position: absolute;*/
        background: white;
        width: 100%;
        /*height: calc(90% - 30px);*/
        overflow: hidden;
        padding-top: 10px;

        > h2 {
            width: 95%;
            margin: 10px auto;
            color: #333333;
        }

        .info-banner {
            width: 85%;
            margin: 10px auto;

            > img {
                width: 100%;
                height: 100%;
                border-radius: 10px;
                object-fit: contain;
            }
        }

        .info-introduce {
            width: 85%;
            margin: 10px auto 20px;
        }

        #fractional-line {
            width: 75vw;
            height: 40vw;
            margin: 10px auto;
            /*border: 1px solid rgba(0, 0, 0, 0.05);*/
            box-shadow: rgba(0, 0, 0, 0.2) 0px 0px 5px; //将h-shadow,v-shadow设为0px,实现四周阴影
            /*box-shadow: 3px 3px 5px rgba(0, 0, 0, 0.05);*/
            border-radius: 6px;
            /*box-sizing: border-box;*/
            padding-bottom: 10px;
        }

        .tab-box {
            margin: 5vw auto 0;
            width: 75vw;
            height: 8vw;
            display: flex;
            align-items: center;
            justify-content: space-between;

            .tab-item {
                width: 15vw;
                height: 5vw;
                border-radius: 5vw;
                border: 1px solid rgba(0, 0, 0, .1);
                color: black;
                text-align: center;
                align-items: center;
                font-size: .8em;
            }

            .tab-focus {
                color: rgb(13, 133, 162);
            }
        }

        .teacher-list {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            flex-wrap: wrap;

            .teacher-item {
                width: 38vw;

                > div:nth-of-type(1) {
                    height: 30vw;
                    overflow: hidden;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    border-radius: 5vw;

                    > img {
                        width: 100%;
                    }
                }

                > div:nth-of-type(2) {
                    font-size: .8em;
                    overflow: hidden;
                    text-overflow: ellipsis;
                    display: -webkit-box;
                    -webkit-line-clamp: 3;
                    -webkit-box-orient: vertical;
                    height: 15vw;
                    line-height: 5vw;
                }

            }
        }

        .school-info-box {
            width: 85%;
            margin: 10px auto;

            > div:nth-of-type(1) {
                margin-top: 20px;
                width: 100%;
            }

            .img-box {
                width: 100%;

                > img {
                    border-radius: 10px;
                    width: 100%;
                }
            }
        }

        .code {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: center;

            img {
                width: 20vw;
                height: 20vw;
                /*margin-right: 10px;*/
            }

            > div {
                width: 125px;
                display: flex;
                flex-direction: column;
                align-items: center;
            }
        }
    }

    .swiper-img {
        width: 100%;
    }

    /**
     资讯更多按钮
     */

    .more-btn {
        width: 170px;
        height: 40px;
        margin: 20px auto;
        text-align: center;
        line-height: 40px;
        color: rgba(118, 118, 118, 1);
        border: 1px solid rgba(0, 0, 0, 0.05);
        box-shadow: 0 3px 5px rgba(0, 0, 0, 0.05);
        border-radius: 20px;
        cursor: pointer;
    }

    .two-line {
        text-overflow: -o-ellipsis-lastline;
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-line-clamp: 3;
        line-clamp: 3;
        -webkit-box-orient: vertical;
    }
</style>
